export default __webpack_public_path__ + "static/media/Icon_eye.d99e4fee.svg";